module.exports = __webpack_public_path__ + "img/Dantam Hair 29.a177b38d.jpg";